import React, { useEffect } from 'react';

import { Grid } from '@mui/material';

import NotaryInfo from '../../components/NotaryInfo';
import Loading from '../../components/loading';
import { useAppDispatch, useAppSelector } from '../../redux-store/hooks';
import { getNotaryByEmailAsync } from '../../redux-store/ipenNotary/ipenNotarySlice';
import { RootState } from '../../redux-store/store';
import './_base.scss';

export default function VerifyNotaryPage() {
  const dispatch = useAppDispatch();
  const userData = useAppSelector((state: RootState) => state.auth.currentUser);

  useEffect(() => {
    const userEmail = userData.email?.toLowerCase();
    if (userEmail) {
      dispatch(getNotaryByEmailAsync(userEmail));
    }
  }, [userData]);

  const ipenNotary: any = useAppSelector(
    (state: RootState) => state.ipenNotary
  );

  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setIsLoading(ipenNotary.isLoading);
  }, [ipenNotary.isLoading]);

  return (
    <div style={{ padding: 20 }}>
      <Grid container>
        <Grid container spacing={2} justifyContent='center'>
          <Grid item xs={12} sm={12} md={12} lg={11}>
            {isLoading ? (
              <Loading />
            ) : (
              <NotaryInfo notary={ipenNotary.notary} />
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
